import { takeEvery, put, call, all, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  PUT_TREATMENT_THERAPIST_FAILURE,
  PUT_TREATMENT_THERAPIST_SUCCESS,
  PUT_TREATMENT_THERAPIST_REQUEST,
} = patientAction;

function* updateTreatmentTherapistAction(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(patientService.getTreatmentTherapist, payload);
    if (response?.status === 200)
      yield put({
        type: PUT_TREATMENT_THERAPIST_SUCCESS,
        payload: response?.data,
      });
    else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: PUT_TREATMENT_THERAPIST_FAILURE, payload: error });
  }
}

function* updateTreatmentTherapistSaga() {
  yield takeEvery(PUT_TREATMENT_THERAPIST_REQUEST, updateTreatmentTherapistAction);
}

export default updateTreatmentTherapistSaga;
